/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface YearPeriod
 */
export interface YearPeriod  {
    /**
     * 
     * @type {number}
     * @memberof YearPeriod
     */
    start?: number;
    /**
     * 
     * @type {number}
     * @memberof YearPeriod
     */
    end?: number;
}

/**
 * Check if a given object implements the YearPeriod interface.
 */
export function instanceOfYearPeriod(value: object): value is YearPeriod {
    return true;
}

export function YearPeriodFromJSON(json: any): YearPeriod {
    return YearPeriodFromJSONTyped(json, false);
}

export function YearPeriodFromJSONTyped(json: any, ignoreDiscriminator: boolean): YearPeriod {
    if (json == null) {
        return json;
    }
    return {
        
                  'start': json['start'] == null ? undefined : json['start'],
                  'end': json['end'] == null ? undefined : json['end'],
    };
}

export function YearPeriodToJSON(json: any): YearPeriod {
    return YearPeriodToJSONTyped(json, false);
}

export function YearPeriodToJSONTyped(value?: YearPeriod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
        'start': value['start'],
        'end': value['end'],
    };
}


